import { useEffect } from 'react';

/**
 * Allows for conditionally locking scrolling.
 * When true is passed in, the user cannot scroll.
 *
 * Only touches the body while it holds a lock. A hook that never locked must not write on
 * unmount: mounted inside a modal that had already hidden body overflow, it used to capture
 * that 'hidden' and write it back after the modal restored scrolling, freezing the page.
 */
const useScrollLock = (lock = true) => {
  useEffect(() => {
    if (!lock) return undefined;

    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [lock]);
};

export default useScrollLock;
